export const FormSubmissionListColumnsModel = [
  {
    label: 'Submission Date',
    property: 'submissionDate',
    type: 'string'
  },
  {
    label: 'Submitted By',
    property: 'submittedBy',
    type: 'string'
  },
  {
    label: 'Customer',
    property: 'customerNumber',
    type: 'string'
  },
  {
    label: 'Site',
    property: 'siteNumber',
    type: 'string'
  },
  {
    label: 'PM Plan',
    property: 'pmPlan',
    type: 'string'
  },
  {
    label: 'Download PDF',
    property: 'surveyPdfKey',
    type: 'string'
  }
];
